import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAF7]" data-testid="auth-loading">
        <span className="font-display text-3xl text-[#0A0A0A]">Perla Music</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children || <Outlet />;
};
